<template>
    <div class="pane-title-container">
        <div class="pane-title">
            <div class="pane-title-left">
                <div class="left-1" />
                <div class="left-2" />
                <div class="left-3" />
                <div class="left-4" />
                <div class="left-5" />
            </div>
            <div class="title">{{ title }}</div>
            <div class="pane-title-right">
                <div class="right-1" />
                <div class="right-2" />
                <div class="right-3" />
                <div class="right-4" />
                <div class="right-5" />
            </div>
        </div>
        <div class="pane-subtitle">
            {{ subTitle }}
        </div>
    </div>
</template>

<script>
export default {
    props: ['title', 'subTitle'],
    name: "PaneTitle",
    computed: {
        lang() {
            return this.$i18n.locale;
        }
    }
}
</script>
<style scoped lang="less">
.pane-title {

    display: flex;
    align-items: center;
    justify-content: center;

    &-left {
        display: flex;
        flex-direction: column;
        align-items: flex-end;

        .left-1 {
            width: 4rem;
            height: 2px;
            background: linear-gradient(270deg, #C7AE7A 0%, #9DC4A1 23%, #0095A3 77%, #007DB0 100%);
            border-radius: 0px 0px 0px 0px;
        }

        .left-2 {
            width: calc(4rem - 3px);
            height: 2px;
            background: linear-gradient(270deg, #C7AE7A 0%, #9DC4A1 23%, #0095A3 77%, #007DB0 100%);
            border-radius: 0px 0px 0px 0px;
            margin-top: 0.25rem;
        }

        .left-3 {
            width: calc(4rem - 6px);
            height: 2px;
            background: linear-gradient(270deg, #C7AE7A 0%, #9DC4A1 23%, #0095A3 77%, #007DB0 100%);
            border-radius: 0px 0px 0px 0px;
            margin-top: 0.25rem;

        }

        .left-4 {
            width: calc(4rem - 9px);
            height: 2px;
            background: linear-gradient(270deg, #C7AE7A 0%, #9DC4A1 23%, #0095A3 77%, #007DB0 100%);
            border-radius: 0px 0px 0px 0px;
            margin-top: 0.25rem;

        }

        .left-5 {
            width: calc(4rem - 12px);
            height: 2px;
            background: linear-gradient(270deg, #C7AE7A 0%, #9DC4A1 23%, #0095A3 77%, #007DB0 100%);
            border-radius: 0px 0px 0px 0px;
            margin-top: 0.25rem;

        }

    }

    .title {
        font-size: 2rem;
        font-weight: bold;
        margin: 0 1.5rem;
       // line-height: 1;
    }

    &-right {
        .right-1 {
            width: 4rem;
            height: 2px;
            background: linear-gradient(270deg, #C7AE7A 0%, #9DC4A1 23%, #0095A3 77%, #007DB0 100%);
            border-radius: 0px 0px 0px 0px;
        }

        .right-2 {
            width: calc(4rem - 3px);
            height: 2px;
            background: linear-gradient(270deg, #C7AE7A 0%, #9DC4A1 23%, #0095A3 77%, #007DB0 100%);
            border-radius: 0px 0px 0px 0px;
            margin-top: 0.25rem;
        }

        .right-3 {
            width: calc(4rem - 6px);
            height: 2px;
            background: linear-gradient(270deg, #C7AE7A 0%, #9DC4A1 23%, #0095A3 77%, #007DB0 100%);
            border-radius: 0px 0px 0px 0px;
            margin-top: 0.25rem;

        }

        .right-4 {
            width: calc(4rem - 9px);
            height: 2px;
            background: linear-gradient(270deg, #C7AE7A 0%, #9DC4A1 23%, #0095A3 77%, #007DB0 100%);
            border-radius: 0px 0px 0px 0px;
            margin-top: 0.25rem;

        }

        .right-5 {
            width: calc(4rem - 12px);
            height: 2px;
            background: linear-gradient(270deg, #C7AE7A 0%, #9DC4A1 23%, #0095A3 77%, #007DB0 100%);
            border-radius: 0px 0px 0px 0px;
            margin-top: 0.25rem;

        }
    }
}

.pane-title-container {
    .pane-subtitle {
        text-align: center;
        font-size: 1.25rem;
        color: var(--secondary-text-color);
        line-height: 1;
    }
}
</style>